import { useEffect } from "react";
import { useAppDispatch } from "@/lib/hooks";
import { setFavourite } from "@/lib/reducers/apiData";

type Identified = { id: string };

export function useFallbackFavourite<T extends Identified>(
  type: "client" | "contract" | "building",
  list: T[] | undefined,
  current: string | undefined
) {
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (!list) return;
    if (current && list.find((c) => c.id == current)) return;
    if (list.length > 0) {
      dispatch(setFavourite({ type, value: list[0].id }));
    }
  }, [type, list, current, dispatch]);
}
